var _circle, _path, _path2, _rect, _rect2, _path3, _path4, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrativeIconGift(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32.5898,
    r: 32,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7701 19.3847L23.6361 19.8848L23.6362 19.8847L22.7701 19.3847ZM26.4887 24.7543L26.3299 25.7416L26.3299 25.7416L26.4887 24.7543ZM29.7201 25.2171L29.5994 26.2098L29.5994 26.2098L29.7201 25.2171ZM29.2318 20.0032L30.0074 19.372L30.0074 19.372L29.2318 20.0032ZM31.2364 22.5282L32.0289 21.9184L31.2364 22.5282ZM21.9041 18.8847C21.375 19.8011 21.0487 21.2828 21.6375 22.7008C22.2553 24.1885 23.7566 25.3275 26.3299 25.7416L26.6476 23.767C24.5232 23.4251 23.7562 22.5877 23.4846 21.9337C23.1841 21.21 23.3473 20.3849 23.6361 19.8848L21.9041 18.8847ZM26.3299 25.7416C27.6264 25.9502 28.7063 26.1012 29.5994 26.2098L29.8408 24.2244C28.9762 24.1193 27.9219 23.972 26.6476 23.767L26.3299 25.7416ZM23.6362 19.8847C23.9231 19.3877 24.5379 18.8586 25.2945 18.7724C25.9858 18.6937 27.0907 18.9567 28.4562 20.6344L30.0074 19.372C28.3694 17.3593 26.6524 16.6048 25.0682 16.7853C23.5493 16.9583 22.435 17.9651 21.9041 18.8848L23.6362 19.8847ZM28.4562 20.6344C29.2626 21.6253 29.9166 22.4529 30.4439 23.1381L32.0289 21.9184C31.4891 21.2168 30.8236 20.3749 30.0074 19.372L28.4562 20.6344ZM29.5994 26.2098C30.7741 26.3526 31.8683 25.9232 32.407 24.9651C32.9437 24.0106 32.7478 22.8526 32.0289 21.9184L30.4439 23.1381C30.7977 23.5978 30.7167 23.8905 30.6636 23.9849C30.6125 24.0759 30.4122 24.2939 29.8408 24.2244L29.5994 26.2098Z",
    fill: "#1A1E23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5531 19.3847L40.6871 19.8848L40.6871 19.8847L41.5531 19.3847ZM37.8345 24.7543L37.9934 25.7416L37.9934 25.7416L37.8345 24.7543ZM34.6032 25.2171L34.7239 26.2098L34.7239 26.2098L34.6032 25.2171ZM35.0915 20.0032L34.3159 19.372L34.3159 19.372L35.0915 20.0032ZM33.0868 22.5282L32.2943 21.9184L33.0868 22.5282ZM42.4191 18.8847C42.9483 19.8011 43.2745 21.2828 42.6857 22.7008C42.0679 24.1885 40.5666 25.3275 37.9934 25.7416L37.6756 23.767C39.8001 23.4251 40.5671 22.5877 40.8386 21.9337C41.1392 21.21 40.9759 20.3849 40.6871 19.8848L42.4191 18.8847ZM37.9934 25.7416C36.6968 25.9502 35.6169 26.1012 34.7239 26.2098L34.4825 24.2244C35.3471 24.1193 36.4014 23.972 37.6756 23.767L37.9934 25.7416ZM40.6871 19.8847C40.4001 19.3877 39.7853 18.8586 39.0287 18.7724C38.3375 18.6937 37.2325 18.9567 35.8671 20.6344L34.3159 19.372C35.9539 17.3593 37.6708 16.6048 39.2551 16.7853C40.774 16.9583 41.8883 17.9651 42.4192 18.8848L40.6871 19.8847ZM35.8671 20.6344C35.0606 21.6253 34.4066 22.4529 33.8793 23.1381L32.2943 21.9184C32.8342 21.2168 33.4996 20.3749 34.3159 19.372L35.8671 20.6344ZM34.7239 26.2098C33.5491 26.3526 32.455 25.9232 31.9163 24.9651C31.3796 24.0106 31.5754 22.8526 32.2943 21.9184L33.8793 23.1381C33.5255 23.5978 33.6065 23.8905 33.6596 23.9849C33.7107 24.0759 33.9111 24.2939 34.4825 24.2244L34.7239 26.2098Z",
    fill: "#1A1E23"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.9199,
    y: 25.5488,
    width: 23.04,
    height: 23.04,
    rx: 1.92,
    fill: "#9C82FA",
    stroke: "#1A1E23",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 25.5488,
    width: 26.8799,
    height: 6.39999,
    rx: 1.92,
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M44 27.5898V26.5898H20V27.5898H44Z",
    fill: "#1A1E23",
    stroke: "#1A1E23",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M43 34.5898V33.5898H22V34.5898H43Z",
    fill: "#1A1E23",
    stroke: "#1A1E23",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30.52,
    y: 25.5488,
    width: 3.83999,
    height: 23.04,
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrativeIconGift);
export default __webpack_public_path__ + "static/media/illustrative-icon-gift.80c38d21657f9a162aeff1d32e2241dc.svg";
export { ForwardRef as ReactComponent };